import AccessibilityBody from './AccessibilityBody';

export default AccessibilityBody;
